import React, { useEffect, useState } from "react";
import BarChart from "../../../statistic/BarChart";
import { useSelector } from "react-redux";

const LastTwelvesMonthsProjects = ({ selectedProjects }) => {
  const { projects } = useSelector((state) => state.projects);
  const [data, setData] = useState();

  const [strategicProjects, setStrategicProjects] = useState([]);

  useEffect(() => {
    setStrategicProjects(
      (selectedProjects || projects || []).filter(
        (p) => p.isStrategic === true
      )
    );
  }, [selectedProjects, projects]);

  const getNext12MonthsForLogic = () => {
    const now = new Date();
    let month = now.getMonth();
    let year = now.getFullYear();
    let res = [];
    for (let i = 0; i < 13; ++i) {
      if (++month === 13) {
        month = 1;
        ++year;
      }
      res.push(year + `-${month > 9 ? "" : "0"}` + month);
    }
    return res;
  };

  const getNext12Months = () => {
    const now = new Date();
    let month = now.getMonth();
    let year = now.getFullYear();
    const monthNames = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Decembre",
    ];
    let res = [];
    for (let i = 0; i < 13; ++i) {
      res.push(monthNames[month] + " " + year);
      if (++month === 12) {
        month = 0;
        ++year;
      }
    }
    return res;
  };

  useEffect(() => {
    const getLengthOfProjectsByDate = (m) => {
      let array = [];
      strategicProjects.forEach((p) => {
        if (p.endDate !== null && p.endDate.includes(m)) {
          array.push(p);
        }
      });
      return array.length;
    };

    setData({
      labels: getNext12Months(),
      datasets: [
        {
          label: "Nombre de projets",
          data: getNext12MonthsForLogic().map((m) =>
            getLengthOfProjectsByDate(m)
          ),
          backgroundColor: "rgba(73, 9, 170, 0.7)",
        },
      ],
    });
  }, [strategicProjects, strategicProjects.length]);
  return (
      <>
        <h2> Nombre de projets à finaliser sur les 12 prochains mois</h2>
        <BarChart chartData={data} />
      </>
  );
};

export default LastTwelvesMonthsProjects;
